import Button from "components/commons/button";
import { ExportModal } from "components/commons/ExportModal";
import Search from "components/commons/search";
import Table from "components/commons/table";
import Toast from "components/commons/toast";
import ViewList from "components/commons/view-list";
import { TABLE_EMPLOYEE_PRODUCTIVITY_DETAIL } from "configs/hr-metrics/configTableEmployeeProductivityList";
import { EmployeeProductivityFilterContainer } from "containers/hr-metrics/employee-productivity/EmployeeProductivityFilterContainer";
import icFileUp from "../../../assets/images/ic-file-up-02.svg";

export const EmployeeProductivityDetail = ({
    dataList,
    isLoading,
    query,
    queryFilter,
    modal,
    selectedIds,
    toast,
    clearToast,
    onChangeQuery,
    setShowModal,
    setSelectedIds,
    onExportHandler,
}) => {

    return (
        <>
            <div className={"flex px-6 py-4 gap-3"}>
                <Search onSearch={(search) => onChangeQuery({page: 1, search})} value={query?.search}/>
                <EmployeeProductivityFilterContainer 
                    queryFilter={queryFilter}
                    onSubmit={(queryFilter) => onChangeQuery({...queryFilter, page: 1})} 
                />
                <ViewList
                    show={modal?.limit}
                    onShow={() => setShowModal({limit: true})}
                    onClose={() => setShowModal({limit: false})}
                    value={query?.limit}
                    onSelectSize={(limit) => onChangeQuery({page: 1, limit})}
                />
                <Button title="Export" icon={icFileUp} type="outline" onClick={() => setShowModal({export: true})}/>
            </div>
            <Table
                className="my-3"
                name={TABLE_EMPLOYEE_PRODUCTIVITY_DETAIL.name}
                columns={TABLE_EMPLOYEE_PRODUCTIVITY_DETAIL.column}
                data={dataList?.results}
                size={query?.limit}
                currentPage={query?.page}
                totalPage={dataList?.total_page}
                totalResult={dataList?.total_result}
                onChangePage={(val) => onChangeQuery({page: val})}
                onClickSort={(val) => onChangeQuery(val)}
                onSelectItem={setSelectedIds}
                loading={isLoading}
            />

            <ExportModal
                title="Apakah anda yakin ingin export data employee productivity ?"
                description={`Total data employee productivity export: ${selectedIds?.length || dataList?.total_result}`}
                show={modal.export}
                onExportHandler={onExportHandler}
                onCancelHandler={() => setShowModal({export: false})}
            />

            <Toast
                show={toast?.isShowToast}
                message={toast?.message}
                onClose={() => clearToast()}
            />
        </>
    )
}
